import { type ModificationGroupLimits } from '../../types';

/**
 * Returns a map of modification group names to their max quantity.
 */
export function getMaxModificationLimits(params: Params) {
  const { modificationLimits } = params;

  return Object.entries(modificationLimits).reduce<MaxModifications>(
    (allEntries, [modificationGroupName, modificationLimit]) => {
      const { maxAggregateQuantity } = modificationLimit;

      return { ...allEntries, [modificationGroupName]: maxAggregateQuantity };
    },
    {},
  );
}

// ─── Types ───────────────────────────────────────────────────────────────────

type Params = {
  modificationLimits: ModificationGroupLimits;
};

type MaxModifications = Record<string, number>;
